//2021-11-10

import Template from 'template';
import t from 'translate';
// import loadHTML from 'loadHTML';

const alerts =
{
	createOverlay: (autoOpen, extraClasses) =>
	{	//2017-08-03 //2021-11-10
		if(typeof(autoOpen) === 'undefined') autoOpen = true;
		extraClasses = extraClasses || [];
		
		return new (function(openAfterInit)
		{
			this.overlay = (new Template('overlay')).compile();
			
			if(extraClasses.length !== 0) this.overlay.classList.add(...extraClasses);
			
			const body = document.querySelector('body');
			const html = document.querySelector('html');
			
			body.appendChild(this.overlay);
			
			this.show = () =>
			{
				html.classList.add('overlaid');
				
				this.overlay.classList.remove('hidden');
			};
			
			this.hide = () =>
			{
				html.classList.remove('overlaid');
				this.overlay.classList.add('hidden');
			};
			
			this.close = () =>
			{
				this.hide();
				this.overlay.remove();
			};
			
			if(openAfterInit) this.show();
		})(autoOpen);
	},
	createDialogBase: () =>
	{// 2022-12-12
		const overlay = alerts.createOverlay(false);
		
		const dialogElement = (new Template('dialogBox')).compile();
		
		overlay.overlay.appendChild(dialogElement);
		
		const headline = dialogElement.querySelector('div.headline');
		headline.classList.add('hidden');
		
		const buttonClose = headline.querySelector('button.close');
		if(buttonClose) buttonClose.addEventListener('click', event => overlay.close());
		
		const dialog =
		{
			overlay: overlay,
			content: overlay.overlay.querySelector('.content'),
			headline: headline
		};
		
		// overlay.overlay.addEventListener('click', event => overlay.close());
		
		return dialog;
	},
	createDialog: (content, contentType, title, buttons, hasCloseButton, loadedCallback, extraClasses) =>
	{	//2017-08-04 //2021-11-10
		content = content || '';
		contentType = contentType || 'text';
		title = title || '';
		buttons = buttons || [];
		hasCloseButton = !!hasCloseButton;
		loadedCallback = loadedCallback || (()=>{});
		extraClasses = extraClasses || [];
		
		const overlay = alerts.createOverlay(true, extraClasses);
		
		const dialogElement = (new Template('dialogBox')).compile();
		
		if(extraClasses.length !== 0) dialogElement.classList.add(...extraClasses);
		
		const headline = dialogElement.querySelector('div.headline');
		
		return new Promise((resolve, reject) =>
		{
			headline.querySelector('div.title').textContent = title;
			headline.classList[(title==='')?'add':'remove']('hidden');
			
			const contentElement = dialogElement.querySelector('div.content');
			if(contentType === 'text')
			{
				contentElement.style.whiteSpace = 'pre-wrap';
				// contentElement.style.fontSize = '15px';
				contentElement.textContent = content;
			}
			else if(contentType === 'html')
			{
				if(typeof content === 'object') contentElement.innerHTML = content.outerHTML;
				else contentElement.innerHTML = content;
			}
			else
			{
				throw 'Invalid content type "'+contentType+'"';
			}
			
			const closeButton = headline.querySelector('button.close');
			closeButton.classList[hasCloseButton?'remove':'add']('hidden');
			closeButton.addEventListener('click', event =>
			{
				overlay.close();
				
				resolve({name: 'close', content: contentElement});
			});
			
			if(hasCloseButton)
			{
				overlay.overlay.addEventListener('click', event =>
				{
					if(event.target === overlay.overlay[0])
					{
						resolve({name: 'close', content: contentElement});
						
						overlay.close();
					}
				});
			}
			
			overlay.buttons = [];
			
			const buttonContainer = dialogElement.querySelector('div.buttons');
			buttons.forEach(buttonSpec =>
			{
				buttonSpec.title = buttonSpec.title || '?';
				buttonSpec.name = buttonSpec.name || 'null';
				buttonSpec.style = buttonSpec.style || 'neutral';		//negative, neutral, positive
				buttonSpec.classes = buttonSpec.classes || [];
				buttonSpec.action = {reject, resolve}[buttonSpec.action] || resolve;	//reject, resolve
				buttonSpec.disabled = !!buttonSpec.disabled || false;
				buttonSpec.validation = buttonSpec.validation || (() => { return true; });
				buttonSpec.timeout = buttonSpec.timeout || 0;
				
				const buttonTpl = (new Template('dialogButton-'+buttonSpec.style)).compile();
				
				buttonTpl.textContent = buttonSpec.title;
				buttonTpl.dataset.buttonName = buttonSpec.name;
				buttonTpl.disabled = buttonSpec.disabled;
				buttonTpl.classList.add(...buttonSpec.classes);
				
				buttonTpl.addEventListener('click', async event =>
				{
					const isValid = await buttonSpec.validation(overlay);
					
					if(isValid)
					{
						buttonSpec.action({ name: buttonSpec.name, content: contentElement });
						
						overlay.close();
					}
				});
				
				if(buttonSpec.timeout !== 0)
				{
					buttonTpl.disabled = true;
					
					const startTime = new Date();
					const intervalID = setInterval(() =>
					{
						const diff = new Date() - startTime;
						
						const secondsLeft = Math.max(0, (buttonSpec.timeout - diff) / 1000);
						
						buttonTpl.textContent = secondsLeft.toPrecision(2);
						
						if(diff >= buttonSpec.timeout)
						{
							clearInterval(intervalID);
							
							buttonTpl.textContent = buttonSpec.title;
							buttonTpl.style.width = '';
							buttonTpl.disabled = false;
						}
					}, 50);
				}
				
				buttonContainer.appendChild(buttonTpl);
				
				overlay.buttons[buttonSpec.name] = buttonTpl;
			});
			
			overlay.overlay.appendChild(dialogElement);
			
			overlay.show();
			
			loadedCallback(overlay, resolve, reject);
			
			// resolve(overlay);
		});
	},
	alert: (message, title, messageType, alertStyle, timeout) =>
	{	//2017-08-04 //2021-11-10
		message = message || '';
		title = title || t('Info');
		messageType = messageType || 'text';
		timeout = timeout || 0;
		
		const buttons =
		[
			{
				title:t('OK'),
				name:'ok',
				style:'neutral',
				action:'resolve',
				timeout: timeout
			}
		];
		
		return alerts.createDialog(message, messageType, title, buttons, false, overlay =>
		{
			const dialog = overlay.overlay.querySelector('.dialog');
			
			if(dialog) dialog.classList.add(alertStyle);
			
			overlay.buttons.ok.focus();
		});
	},
	confirm: (message, title, messageType, confirmStyle) =>
	{	//2017-08-04
		message = message || '';
		title = title || t('Confirm');
		messageType = messageType || 'text';
		confirmStyle = confirmStyle || 'positive';
		
		const buttons =
		[
			{
				title:t('Cancel'),
				name:'cancel',
				style:'neutral',
				// action:'reject'
				action:'resolve'
			},
			{
				title:t('OK'),
				name:'ok',
				style:confirmStyle,
				action:'resolve'
			}
		];
		
		return alerts.createDialog(message, messageType, title, buttons, false, overlay =>
		{
			overlay.buttons.ok.focus();
		});
	},
	choice:function(message, title, messageType)
	{	//2023-11-17
		message = message || '';
		title = title || t('Choice');
		messageType = messageType || 'text';
		
		const buttons = 
		[
			{
				title:t('Cancel'),
				name:'cancel',
				style:'neutral',
				action:'resolve'
			},
			{
				title:t('No'),
				name:'false',
				style:'negative',
				action:'resolve'
			},
			{
				title:t('Yes'),
				name:'true',
				style:'positive',
				action:'resolve'
			}
		];

		return this.createDialog(message, messageType, title, buttons, false, overlay =>
		{
			overlay.buttons.true.focus();
		});
	},
	prompt: (title, message, defaultValue, multiLine, openCallback, validationCallback) =>
	{	//2017-08-04 //2021-11-10
		title = title || '';
		message = message || '';
		defaultValue = defaultValue || '';
		multiLine = !!(multiLine === true);
		openCallback = openCallback || (()=>{});
		
		let input = null;
		let inputElement = null;
		
		if(multiLine)
		{
			input = (new Template('dialogPromptTextArea')).compile({message: message});
			inputElement = input.querySelector('textarea');
		}
		else
		{
			input = (new Template('dialogPromptInput')).compile({message: message});
			inputElement = input.querySelector('input');
		}
		
		inputElement.setAttribute('name', 'value');
		inputElement.value = defaultValue;
		
		const buttons =
		[
			{
				title:t('Cancel'),
				name:'cancel',
				style:'neutral',
				action:'resolve'
			},
			{
				title:t('OK'),
				name:'ok',
				style:'positive',
				action:'resolve',
				validation: validationCallback
			}
		];
		
		const dialogPromise = alerts.createDialog(input, 'html', title, buttons, false, overlay =>
		{
			const inputElement = overlay.overlay.querySelector('input,textarea');
			inputElement.focus();
			
			inputElement.addEventListener('keydown', event =>
			{
				if(event.which == 27) overlay.buttons.cancel.click();
				if(event.which == 13) overlay.buttons.ok.click();
			});
			
			openCallback(overlay);
		});
		
		return new Promise((resolve, reject) =>
		{
			dialogPromise.then(({name: name, content: content}) =>
			{
				const input = content.querySelector(multiLine ? 'textarea' : 'input');
				
				resolve({name: name, content: content, value: input.value});
			})
			.catch((error) =>
			{
				console.error(error);
				
				reject(error);
			});
		});
	},

	infoBox: (title, message, messageType, extraClass, onLoaded) =>
	{	//2017-08-04 //2021-11-10
		message = message || '';
		title = title || '';
		messageType = messageType || 'text';
		extraClass = extraClass || '';
		var extraClasses = [];
		onLoaded = onLoaded || ((overlay, resolve, reject)=>{ resolve(overlay); });
		
		if(extraClass !== '') extraClasses.push(extraClass);
		
		return alerts.createDialog(message, messageType, title, null, true, onLoaded, extraClasses);
	},
	buttonDialog:function(title, message, buttons, messageType, loadedCallback)
	{	//2016-12-12 //2021-11-10
		/*
		usage:
			admin.buttonDialog('Alert', 'This is a test message',
			[
				{
					title:t('Cancel'),
					name:'cancel',
					style:'neutral',
					action:'resolve'
				},
				{
					title:t('OK'),
					name:'ok',
					style:'positive',
					action:'resolve'
				}
			], 'text')
		*/
		
		messageType = messageType || 'text'; // text | html
		
		return alerts.createDialog(message, messageType, title, buttons, false, loadedCallback);
	}
};

window._alert = window.alert;	//lets keep a backup
window.alert = (msg) =>
{
	window._alert('Don\'t use alert(), use alerts.alert() instead!\r\nOriginal message: '+msg);
};

window._confirm = window.confirm;
window.confirm = (msg) =>
{
	window._alert('Don\'t use confirm(), use alerts.confirm() instead!\r\nOriginal message: '+msg);
};

export default alerts;
